import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyBetween
        >
          <CFView w="100%" textCenter mt="5%">
            <CFImage
              w="95%"
              maxWidth="500px"
              src={mobileHeroText}
              alt="Dodam Korean hero text"
              zIndex={98}
            />
          </CFView>
          <CFView textCenter column center mb="7%" w="100%">
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="650px"
          w="100%"
          image={`url(${hero}) left / cover no-repeat`}
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25);"
          zIndex={90}
          column
        >
          <CFView column justifyCenter alignEnd mr="6%" h="100%" mt="15px">
            <CFImage
              w="50%"
              maxWidth="540px"
              src={heroText}
              alt="Dodam Korean hero text"
              zIndex={98}
            />
            <CFView pulsate mr="5%" mt="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
